import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.bundle'
import Navbar from './component/Navbar'


function App() {
  return (
    <div className="App">
        <Navbar />
    </div>
  );
}

export default App;
